module.exports = __webpack_public_path__ + "static/media/step_1.c03cb098.mp3";